import * as DM from '@radix-ui/react-dropdown-menu';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/lib/auth/useAuth';
import { Tag } from '@/lib/ui/Tag';

export function AccountMenu() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  if (!user) return null;
  // `name` may be absent depending on the backend's /admin/me payload; fall back to
  // the email local-part so the header never crashes on an incomplete user object.
  const displayName = user.name?.trim() || user.email?.split('@')[0] || '';
  const initials =
    displayName
      .split(/\s+/)
      .map((p) => p[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase() || '?';
  return (
    <DM.Root>
      <DM.Trigger
        className="flex items-center gap-sm rounded-sm px-xs py-[4px] hover:bg-canvas-sand focus-visible:shadow-focus"
        aria-label={t('nav.account')}
      >
        <span className="flex h-[30px] w-[30px] items-center justify-center rounded-pill bg-ink-deep font-mono text-label text-canvas-paper">
          {initials}
        </span>
      </DM.Trigger>
      <DM.Portal>
        <DM.Content
          align="end"
          sideOffset={6}
          className="z-[95] min-w-[220px] rounded-md border-[0.5px] border-hairline bg-canvas-paper p-xs shadow-nav-scrolled"
        >
          <div className="px-sm py-xs">
            <p className="text-small font-medium text-ink-deep">{displayName}</p>
            <p className="text-small text-ink-mute">{user.email}</p>
            <div className="mt-xs flex items-center gap-xs">
              <Tag variant="neutral">{user.role}</Tag>
              {user.mfa_enabled && <Tag variant="teal">{t('account.mfaBadge')}</Tag>}
            </div>
          </div>
          <DM.Separator className="my-xs h-[0.5px] bg-hairline" />
          <DM.Item asChild>
            <Link
              to="/account"
              className="block cursor-pointer rounded-sm px-sm py-xs text-small text-ink-graphite outline-none hover:bg-canvas-sand"
            >
              {t('nav.account')}
            </Link>
          </DM.Item>
          <DM.Item
            onSelect={() => void logout()}
            className="cursor-pointer rounded-sm px-sm py-xs text-small text-signal-error outline-none hover:bg-signal-error-fill"
          >
            {t('nav.signOut')}
          </DM.Item>
        </DM.Content>
      </DM.Portal>
    </DM.Root>
  );
}
